import React from 'react';
import { useIntl } from 'react-intl';

import { Notification } from '@xsolla/ui-core';

import { PASSWORDLESS_LOGIN } from '../../../constants';
import { CurrentProjectType } from '../../../contexts/settings/types';
import { HorizontalCenterBlock } from '../../../styled';
import { FieldSwitch, FormLabel, Notice } from '../../ui';
import { ContentWrapper, NotificationWrapper, ValidationSwitchWrapper } from './style';

type Props = {
  currentProjectType: CurrentProjectType;
};

const EmailValidation = ({ currentProjectType }: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <HorizontalCenterBlock>
      <ContentWrapper>
        {currentProjectType === PASSWORDLESS_LOGIN && (
          <FormLabel
            label={intl.formatMessage({ id: 'settings.email-validation.title' })}
            description={intl.formatMessage({ id: 'settings.email-validation.subtitle' })}
          />
        )}

        <NotificationWrapper>
          <Notification palette="brand" icon={Notice}>
            {intl.messages['settings.email-validation.notification.label']}
          </Notification>
        </NotificationWrapper>
        <ValidationSwitchWrapper>
          <FieldSwitch
            name="email_confirmation_needed"
            data-test-id="email_confirmation_needed"
            caption={intl.formatMessage({
              id: 'settings.email-validation.confirmation.switch.caption'
            })}
            label={intl.formatMessage({
              id: 'settings.email-validation.confirmation.switch.title'
            })}
          />
        </ValidationSwitchWrapper>
        <ValidationSwitchWrapper>
          <FieldSwitch
            name="enable_smtp"
            data-test-id="enable_smtp"
            caption={intl.formatMessage({
              id: 'settings.email-validation.smtp.switch.caption'
            })}
            label={intl.formatMessage({ id: 'settings.email-validation.smtp.switch.title' })}
          />
        </ValidationSwitchWrapper>
        <ValidationSwitchWrapper>
          <FieldSwitch
            name="enable_rfc"
            data-test-id="enable_rfc"
            caption={intl.formatMessage({
              id: 'settings.email-validation.rfc.switch.caption'
            })}
            label={intl.formatMessage({ id: 'settings.email-validation.rfc.switch.title' })}
          />
        </ValidationSwitchWrapper>
        <ValidationSwitchWrapper>
          <FieldSwitch
            name="enable_graylist"
            data-test-id="enable_graylist"
            caption={intl.formatMessage({
              id: 'settings.email-validation.gray-list.switch.caption'
            })}
            label={intl.formatMessage({ id: 'settings.email-validation.gray-list.switch.title' })}
          />
        </ValidationSwitchWrapper>
      </ContentWrapper>
    </HorizontalCenterBlock>
  );
};

export default EmailValidation;
